// extracted by mini-css-extract-plugin
export default {"contacts":"ApplicantContacts_contacts__s0XJd"};